import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'

import { FooterComponent } from '@shared/footer/footer.component'
import { CookieBannerComponent } from './shared/cookie-banner/cookie-banner.component'

import { HeaderComponent } from '@shared/header-navbar/header.component'
import { CommonModule } from '@angular/common'
import { filter, Subscription } from 'rxjs'

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  standalone: true,
  imports: [RouterModule, HeaderComponent, FooterComponent, CookieBannerComponent, CommonModule],
})
export class PublicMainComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription = new Subscription()
  showHeaderFooter = true

  constructor(private router: Router) {}

  ngOnInit() {
    this.showHeaderFooter = this.router.url !== '/login'

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showHeaderFooter = event.url !== '/login'
      })
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe()
    }
  }

  onActivate() {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
}
